<template>
  <div class="cont">
  <div class="toutu">
    <img src="../../assets/koubei.jpg"></div>
  <div class="div_t">

        <div class="koubei_hang" style="margin-top: 109px">
      <div class="kb_hang_left">
        <img class="kb_img" src="../../assets/1-1Z530093256159.jpg">
        <span class="kb_title">@Beauty</span>
        <div class="kb_txt">燕窝很好，朋友买的跟我买的的品质差不多，但是1g却比我的贵将近10块，真心感觉很不错</div>
      </div>
      <div class="kb_hang_right">
        <img class="kb_img" src="../../assets/1-1Z53009330V19.jpg">
        <span class="kb_title">@小嘎哈</span>
        <div class="kb_txt">朋友介绍来的，已经买2次了，燕窝品质很不错，自己也能做的很好吃</div>
      </div>
    </div>

    <div class="koubei_hang">
      <div class="kb_hang_left">
        <img class="kb_img" src="../../assets/1-1Z524145A6291.jpg">
        <span class="kb_title">@sleep</span>
        <div class="kb_txt">燕窝品质果然不错，而且不用挑毛哈哈哈，以后也认准你啦！</div>
      </div>
      <div class="kb_hang_right">
        <img class="kb_img" src="../../assets/1-1Z524145RY56.jpg">
        <span class="kb_title">@粉红小猪</span>
        <div class="kb_txt">之前买的还有，这次囤点准备送人，价格也比较合适，主要是品质有保证~</div>
      </div>
    </div>

    <div class="koubei_hang">
      <div class="kb_hang_left">
        <img class="kb_img" src="../../assets/1-1Z524145923361.jpg">
        <span class="kb_title">@love253</span>
        <div class="kb_txt">加了点草莓当早餐，口感挺清爽Q弹的，不错！</div>
      </div>
      

      <div class="kb_hang_right">
        <img class="kb_img" src="../../assets/1-1Z524150203952.jpg">
        <span class="kb_title">@一只小小鸟</span>
        <div class="kb_txt">送的泡发工具真的是太实用了，燕窝泡发完也基本上没有毛，直接炖就行了，很方便。</div>
      </div>
    </div>

    <div class="koubei_hang">
      
      <div class="kb_hang_left" >
        <img class="kb_img" src="../../assets/1-1Z5241KH1357.jpg">
        <span class="kb_title">@Miss G</span>
        <div class="kb_txt">燕窝品质特别好，而且服务也特别好。开始对燕窝根本是不懂的，都是小慧给我一步一步讲解，收到后告诉我怎么炖煮，而且还给我介绍了很多关于孕期的知识，真的是非常感谢~</div>
      </div>

      <div class="kb_hang_right" >
        <img class="kb_img" src="../../assets/1-1Z52415032C45.jpg">
        <span class="kb_title">@小仙女</span>
        <div class="kb_txt">满意，吃了很多年燕窝，还算是有点心得，发头很大，杂质也很少，品质确实不错，这一批吃完还会继续买的，周围有朋友也一起吃，给推荐客户，小慧还送了瓶燕窝胶原蛋白哦~</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
	
export default {
  name: 'praise',
  data () {
    return {
      
    }
  },
  methods:{
			
		}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.toutu {
    width: 1120px;
    margin: auto;
}

.toutu img {
    width: 100%;
}

.cont {
    width: 1120px;
    margin: 0 auto;
    height: 100%;

}

.logo {
    margin-left: 449px;
    margin-top: 72px;
}


.div_t_div {
    width: 1120px;
    height: 500px;
    position: relative;
}

.div_t_div_img1 {
    width: 500px;
    position: absolute;
}

.div_t_div_img2 {
    position: absolute;
    margin-left: 400px;
    top: 62px;
    z-index: 1;
    height: 280px;
    width: 700px;
}

.text1 {
    position: absolute;
    margin-left: 580px;
    top: 94px;
    z-index: 3;
    width: 500px;
}

.text1 li {
    display: block;
    font-size: 26px;
    letter-spacing: 3px;
    color: #1b1b1b;
    margin-left: 0px;
}

.hrs {
    height: 1px;
    border: none;
    border-top: 1px solid #35b597;
    width: 426px;
    margin-left: 0px;
    margin-top: 16px;
    float: left;
}

.text1_p {
    font-size: 16px;
    text-indent: 2em;
    float: right;
    margin-right: 50px;
    margin-top: 10px;
    line-height: 39px;
    color: #1b1b1b;
    letter-spacing: 1px;
}

.div_c {
    width: 1120px;
    margin: 0 auto;
    margin-top: 0px;
    height: 500px;
    position: relative;
}

.div_c_img1 {
    width: 500px;
    margin-left: 620px;
    position: absolute
}

.div_c_img2 {
    position: absolute;
    top: 50px;
    z-index: 1;
    height: 280px;
    margin-left: 50px;
    width: 700px;
}

.text2 {
    position: absolute;
    /*margin-left: 100px;*/
    top: 82px;
    z-index: 3;
    width: 500px;
}

.text2_li {
    display: block;
    font-size: 26px;
    letter-spacing: 5px;
    color: #1b1b1b;
}

.text2_p {
        font-size: 16px;
    text-indent: 2.3em;
    line-height: 39px;
    color: #1b1b1b;
    margin-top: 32px;
    margin-left: 0px;
    letter-spacing: 3px;
}
.div_t {
    width: 1120px;
    margin: auto;
    margin-top: 84px;
    margin-bottom: 86px;
}
.koubei_hang {
    margin-top: 80px;
    height: 459px;
    width: 945px;
    margin-left: auto;
    margin-right: auto;
}
.koubei_hang::after{content: "";clear: both; display: block; width: 100%; height: 1px;}
.kb_hang_left {
    float: left;
    width: 430px;
    min-height: 443px;
    box-shadow: 2px 3px 10px #999;
}
.kb_img {
    width: 430px;
    height: 266px;
    display: block;
}
.kb_title {
    font-size: 18px;
    color: #daa520;
    height: 67px;
    line-height: 79px;
    border-bottom: 1px solid #daa520;
    display: block;
    padding-left: 15px;
}
.kb_txt {
    min-height: 40px;
    line-height: 28px;
    padding-top: 15px;
    font-size: 16px;
    color: #444;
    padding-left: 15px;
    padding-bottom: 15px;
    padding-right: 8px;
}
.kb_hang_right {
    float: right;
    width: 430px;
    min-height: 443px;
    box-shadow: 2px 3px 10px #999;
}
@media(max-width: 750px) {
   .cont{width:100%; margin: 0 auto;}
   .toutu{ width: 100%; overflow: hidden}
   .toutu img{ width: 100%; margin-left: 0%;}
  .div_t{ width: 690px;}
  .koubei_hang{ width: 100%;}
  .kb_hang_left{ width: 48%;}
  .kb_img{ max-width: 100%; height: 230px;}
  .kb_hang_right{ width: 48%}
  .kb_title{ font-size: 30px}
  .kb_txt{ height: auto; font-size: 24px; overflow : hidden;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 4;
-webkit-box-orient: vertical;}
  .koubei_hang{ margin-top: 40px}
}     

</style>




// WEBPACK FOOTER //
// src/components/praise/praise.vue